module.exports = __webpack_public_path__ + "static/front/img/product.09c01ba3.svg";